import { Phrases } from '@shared/model/locales.model';

export default {
  FailedToLogout: 'Failed To Logout',
  LoggedOutSuccessfully: 'Logged Out Successfully'
} as Phrases;
